export default __webpack_public_path__ + "static/media/testimonial1.11ebe3eb.svg";